import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { t } from 'i18next';

const TableProperty = ({ property, tableRef }) => {
    return (
        <TableContainer
            sx={{}}
            style={{ display: 'none' }}
        >
            <Table ref={tableRef}>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('name_property')}</TableCell>
                        <TableCell>{t('value_property')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {property?.length > 0 &&
                        property.map((ele, index) => (
                            <TableRow key={index}>
                                <TableCell>{ele?.label}</TableCell>
                                <TableCell>
                                    {Array.isArray(ele?.value) && ele?.value.length > 0 ? ele.value.join(', ') : ''}
                                </TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TableProperty;
